import { AmqpTopic } from "@legacy-megarax/amqp";
import { DateString, dateStringSerializer, Uuid, uuidSerializer } from "@legacy-megarax/common";
import { MSerializers } from "@legacy-megarax/serializers";

export type ScheduleDayEventMessage = {
  userId: number;
  date: DateString;
};

export const scheduleDayEventMessageSerializer = MSerializers.object<ScheduleDayEventMessage>({
  date: dateStringSerializer,
  userId: MSerializers.integer,
});

export const scheduleDayEventAmqpTopic: AmqpTopic<ScheduleDayEventMessage> = {
  key: "crm.visit-schedule.day-event",
  serializer: scheduleDayEventMessageSerializer,
};

export type ScheduleVisitEventMessage = {
  visitUuid: Uuid;
  customerUuid: Uuid;
};

export const scheduleVisitEventMessageSerializer = MSerializers.object<ScheduleVisitEventMessage>({
  visitUuid: uuidSerializer,
  customerUuid: uuidSerializer,
});

export const scheduleVisitEventAmqpTopic: AmqpTopic<ScheduleVisitEventMessage> = {
  key: "crm.visit-schedule.schedule-visit-event",
  serializer: scheduleVisitEventMessageSerializer,
};
